import { useConstant } from "./use-constant";

/** Returns true if the user is using a mac os */
export const useIsMac = () => useConstant(() => navigator.userAgent.includes("Mac"));

export const useCtrlKey = () => useConstant(() => (navigator.userAgent.includes("Mac") ? "⌘" : "CTRL"));
